import { useEffect } from "react";
import { fetchCurrentUser } from "../../utils/apiUtils";
import { isAvatarBg, useSettingsStore } from "../../store/settingsStore";
import { avatarFileUrl } from "./useAvatarSrc";

const useAvatarTheme = () => {
    const setAvatarBg = useSettingsStore((state) => state.setAvatarBg);
    const setAvatar = useSettingsStore((state) => state.setAvatar);

    useEffect(() => {
        let cancelled = false;
        fetchCurrentUser()
            .then((user) => {
                if (cancelled) return;
                if (isAvatarBg(user?.color)) setAvatarBg(user.color);
                setAvatar({
                    url: user?.avatarKey || user?.avatarUrl ? avatarFileUrl(user?.pk) : "",
                    key: user?.avatarKey || "",
                });
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [setAvatar, setAvatarBg]);
};

export { useAvatarTheme };
